import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import { myListsDetailsOptionsStyles } from "@WhiteCap/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import { css } from "styled-components";

// EC-761 : My List Details Page : Added dynamic css through code
myListsDetailsOptionsStyles.addItemsLink = {
    icon: {
        iconProps: { src: PlusCircle },
    },
    typographyProps: {
        css: css`
            padding-left: 5px;
        `,
    },
    mergeCss: true,
    css: css`
        > span > svg {
            color: #474747;
        }
    `,
};
// EC-761 : My List Details Page : Added dynamic css through code
